import React from 'react';
import {useLanguage} from "../../contexts/LanguageContext.tsx";

interface AiModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AiServiceModal: React.FC<AiModalProps> = ({
  isOpen,
  onClose,
}) => {

  const { translations } = useLanguage();

  const listService = [
    {
      title: translations.OurServiceText1,
      textList: [
        {
          text: translations.OurServiceTextList1,
        },
        {
          text: translations.OurServiceTextList2,
        },
        {
          text: translations.OurServiceTextList3,
        }
      ]
    },
    {
      title: translations.OurServiceText2,
      textList: [
        {
          text: translations.OurServiceText2List1,
        },
        {
          text: translations.OurServiceText2List2,
        },
        {
          text: translations.OurServiceText2List3,
        }
      ]
    },
    {
      title: translations.OurServiceText3,
      textList: [
        {
          text: translations.OurServiceText3List1,
        },
        {
          text: translations.OurServiceText3List2,
        },
        {
          text: translations.OurServiceText3List3,
        }
      ]
    }
  ]
  const listService2 = [
    {
      title: translations.OurServiceText4,
      textList: [
        {
          text: translations.OurServiceText4List1,
        },
        {
          text: translations.OurServiceText4List2,
        },
        {
          text: translations.OurServiceText4List3,
        }
      ]
    },
    {
      title:  translations.OurServiceText5 ,
      textList: [
        {
          text: translations.OurServiceText5List1,
        },
        {
          text: translations.OurServiceText5List2,
        },
        {
          text: translations.OurServiceText5List3,
        }
      ]
    },
    {
      title: translations.OurServiceText6,
      textList: [
        {
          text: translations.OurServiceText6List1,
        },
        {
          text: translations.OurServiceText6List2,
        },
        {
          text: translations.OurServiceText6List3,
        }
      ]
    }
  ]

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-2">
      <div className="bg-white rounded-lg max-w-6xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6 pt-0">
          <div className="flex justify-between items-start sticky-btn ">
            <h3 className="text-2xl font-light"></h3>
            <button
                onClick={onClose}
                className="bg-gray-400/50 hover:bg-gray-500/50 transition-colors rounded-full p-2"
            >
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div className="m-2 bg-[#84a0ae] rounded-lg p-10 md:p-14">
            <div>
              <h1 className="text-md  text-[#d3edfc] fon-medium">{translations.OUR_AI_SERVICES}</h1>


              <div className="grid grid-cols-1 md:grid-cols-2 gap-2 border-t-2 border-[#d3edfc] mt-4 pt-4 md:px-5">
                <ul className="list-decimal text-[#d3edfc] text-md">
                  {listService.map(item => {
                    return <li className="mt-4"> <h6 className="font-medium">{item.title}</h6>

                                <ul className="list-[square] ml-4 font-light">
                                  {item.textList.map(d => {
                                    return <li>{d.text} </li>
                                  })}
                                </ul>

                    </li>
                  })}
                </ul>

                <ol className="list-decimal text-[#d3edfc] text-md" start={4}>
                  {listService2.map(item => {
                    return<li className="mt-4"> <h6 className="font-medium">{item.title}</h6>

                      <ul className="list-[square] ml-4 font-light">
                        {item.textList.map(d => {
                          return <li>{d.text} </li>
                        })}
                      </ul>

                    </li>
                  })}
                </ol>

              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default AiServiceModal;
